module.exports = __webpack_public_path__ + "static/img/illustration.c2834415.png";